import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceType {
  asset_type_id: string
  asset_type_name: string
  category_type_id: string
  category_type_name: string
  isCustomDevice: boolean
  isDeviceModelApplicable: boolean
}

export interface DeviceTypeState {
  isLoading: boolean
  loadingError: string | null
  deviceType: DeviceType[] | null
  httpStatus: number | null
}

export const initialState: DeviceTypeState = {
  isLoading: true,
  loadingError: null,
  deviceType: null,
  httpStatus: null
}

const deviceTypeSlice = createSlice({
  name: 'deviceManagementDeviceType',
  initialState,
  reducers: {
    deviceTypeLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        deviceType: null,
        httpStatus: 0
      }
    },
    deviceTypeUpdateAction: (state, action: PayloadAction<{ data: DeviceType[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        deviceType: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    deviceTypeErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        deviceType: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  deviceTypeLoadingAction,
  deviceTypeUpdateAction,
  deviceTypeErrorAction
} = deviceTypeSlice.actions

export default deviceTypeSlice.reducer
